import { Capacitor, registerPlugin } from '@capacitor/core'
import type { Router } from 'vue-router'

/**
 * Tapping the daily check-in reminder opens the check-in page (M-112).
 *
 * Without this the notification fires, somebody taps it, and the app opens
 * wherever it happened to be. The route travels in the notification's `extra`
 * and is read back here.
 *
 * Reached by plugin name rather than by importing the package, exactly as the
 * App Links handler beside this file does: it keeps the web build free of a
 * native dependency it can never use.
 */
interface ActionPerformed {
  notification: { extra?: { route?: unknown } }
}

interface LocalNotificationsPlugin {
  addListener(
    event: 'localNotificationActionPerformed',
    fn: (data: ActionPerformed) => void,
  ): Promise<{ remove: () => Promise<void> }>
}

const LocalNotifications = registerPlugin<LocalNotificationsPlugin>('LocalNotifications')

export function routeNotificationTaps(router: Router): void {
  if (!Capacitor.isNativePlatform()) return
  void LocalNotifications.addListener('localNotificationActionPerformed', ({ notification }) => {
    const route = notification?.extra?.route
    // Only a path of our own, never anything that could be turned into an
    // external destination by whatever ends up putting notifications out.
    if (typeof route !== 'string' || !route.startsWith('/') || route.startsWith('//')) return
    void router.push(route)
  })
}
